import React from "react";

const Loader = () => {
  return <h2 className="font-bold text-black">Chargement...</h2>;
};

export default Loader;
